import { prospectRequestManager } from "@core/service-container";
import { ProspectRequestConfig, ProspectRequestReferential } from "@domain/prospect-request/prospect-request";

import { isNotNil } from "@utils/assert";
import { useCallback, useState } from "react";

interface UseProspectRequestFormHook {
	referential: ProspectRequestReferential;
	selectReferential: (countryCode: string) => void;
}

export const useProspectRequestReferential = (config: ProspectRequestConfig): UseProspectRequestFormHook => {
	const [referential, setReferential] = useState(
		config.referentialsMap.get(config.initialCountryCode) as ProspectRequestReferential,
	);

	const selectReferential = useCallback(
		(countryCode: string) => {
			const newReferential = config.referentialsMap.get(countryCode);
			if (isNotNil(newReferential)) {
				setReferential(newReferential);
				prospectRequestManager.selectCountry(countryCode);
			}
		},

		[config.referentialsMap],
	);

	return { referential, selectReferential };
};
